import ArchetypeCard from "./ArchetypeCard";
import type { DetectedArchetype } from "@/lib/archetypes";

interface Props {
  detected: DetectedArchetype[];
}

const ObservedArchetypesSection = ({ detected }: Props) => {
  if (!detected.length) return null;
  const [primary, ...rest] = detected;

  return (
    <section className="space-y-3">
      <p className="text-[10px] font-semibold tracking-widest uppercase text-muted-foreground">
        Observed Archetypes
      </p>

      <ArchetypeCard
        archetype={primary.archetype}
        confidence={primary.confidence}
        evidenceTurns={primary.evidenceTurns}
        variant="full"
      />

      {rest.length > 0 && (
        <div className="space-y-2">
          <p className="text-[9px] font-mono tracking-[0.24em] uppercase text-muted-foreground/55 pl-1">
            Secondary Tendencies
          </p>
          {rest.map((d) => (
            <div
              key={d.archetype.key}
              className="rounded-lg border border-border/40 bg-card/30 px-4 py-3 flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground/90 truncate">
                  {d.archetype.name}
                </p>
                <p className="text-xs text-foreground/55 truncate font-light">
                  {d.archetype.short}
                </p>
              </div>
              <span className="text-[9px] font-mono tracking-[0.18em] uppercase text-cyan/50 shrink-0">
                {Math.round(d.confidence * 100)}%
              </span>
            </div>
          ))}
        </div>
      )}

      <p className="text-[9px] font-mono tracking-[0.22em] uppercase text-muted-foreground/35 pl-1">
        Behavioral recognition · Not a diagnosis
      </p>
    </section>
  );
};

export default ObservedArchetypesSection;
